import { Grid } from '@mui/material';
import styled from '@emotion/styled';
import { theme } from 'config';

export const Container = styled(Grid)(
  {
    transition: 'all 0.3s',
    position: 'fixed',
    zIndex: '999! important',
    left: '0',
    top: '0',
    right: '0',
    bottom: '0',
    height: '100%',
    width: '100%',
    padding: '0 20px',
    margin: '0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'rgba(0, 0, 0, 0.6)',
    overflow: 'hidden',

    [theme.breakpoints.down('sm')]: {
      padding: '0 10px',
    },
  },
  ({ open }) => ({
    visibility: open ? 'visible' : 'hidden',
    opacity: open ? '1' : '0',
  })
);
